<template>
    <div>
        <!-- Create Admission Form Button -->
        <b-button v-if="!admissiondesk" size="sm" variant="info" @click="showForm = true;">
            <i class="fas fa-plus-square text-white" style="font-size: 16px !important;"></i>
            Create
        </b-button>

        <!-- Admission Form List -->
        <table class="table table-striped table-bordered mt-3" v-if="admissionForms.length > 0">
            <thead class="thead-dark text-left">
                <tr>
                    <th>No.</th>
                    <th>Name</th>
                    <th v-if="!admissiondesk"></th>
                    <th v-if="!admissiondesk"></th>
                    <th v-if="!admissiondesk"></th>
                    <th v-if="!admissiondesk"></th>
                    <!-- <th></th> -->
                    <th>Academic Year</th>
                    <th>Semester</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th v-if="!admissiondesk">Public URL</th>
                    <th v-if="!admissiondesk"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(form, index) in admissionForms" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ form.name }}
                        <b-badge v-if="form.form_type == 1" pill variant="primary"
                            style="font-size: 10px; font-weight: 600; color: #fff;">
                            Enquiry/Admission Form
                        </b-badge>
                        <b-badge v-else-if="form.form_type == 2" pill variant="success"
                            style="font-size: 10px; font-weight: 600; color: #fff;">
                            Semester Registration Form
                        </b-badge>
                    </td>
                    <td v-if="!admissiondesk">
                        <a @click="createSection(form.id)" class="text-primary font-weight-bold text-decoration-none"
                            style="cursor: pointer;">
                            Create Form
                        </a>
                    </td>
                    <td v-if="!admissiondesk">
                        <a @click="openHeaderModal(form)" class="text-decoration-none" style="cursor: pointer;">
                            <span v-if="!form.header_type || form.header_type === 'default'">
                                Standard Header
                            </span>
                            <span v-else-if="form.header_type === 'custom'">Custom Header</span>
                        </a>
                    </td>
                    <td>
                        <a @click="approvalOverview(form.id)" class="text-primary font-weight-bold text-decoration-none"
                            style="cursor: pointer;">
                            Approval Over View
                        </a>
                    </td>
                    <td>
                        <a @click="viewAdmissionForm(form.id)" class="text-primary font-weight-bold text-decoration-none" style="cursor: pointer;">
                            Student Response Overview
                        </a>
                    </td>
                    <td>{{ form.academic_year }}</td>
                    <td>{{ form.academic_semester ? form.academic_semester.charAt(0).toUpperCase() + form.academic_semester.slice(1) : '-' }}</td>
                    <td>{{ formatDate(form.start_date) }}</td>
                    <td>{{ formatDate(form.end_date) }}</td>

                    <td class="text-center" v-if="!admissiondesk">
                        <template v-if="form.form_type != 2">
                            <span v-if="form.id" class="text-info text-center btn p-0 m-0" :id="'url' + index">
                                <i class="fas fa-link" style="font-size: 15px!important;"></i>
                            </span>
                            <span class="text-danger" v-else>No Link!</span>

                            <b-popover v-if="form.id" :target="'url' + index" triggers="hover" placement="top">
                                <template #title>Click the link to copy</template>
                                <span class="text-info btn p-0 m-0" @click="copyLink(index)">
                                    {{ publicFormUrl(form) }}
                                </span>
                            </b-popover>
                        </template>
                        <span v-else>-</span>
                    </td>
                    <td v-if="!admissiondesk">
                        <!-- Copy -->
                        <i class="fas fa-copy text-success ml-2" style="font-size: 15px!important;cursor: pointer;"
                            title="Copy form" @click="openCopyModal(form)"></i>

                        <!-- Edit -->
                        <i class="fas fa-edit text-info ml-2" style="font-size: 15px!important;cursor: pointer;"
                            @click="editAdmissionForm(form)"></i>
                    </td>

                </tr>
            </tbody>
        </table>


        <!-- Admission Form Section List -->
        <table class="table table-striped table-bordered mt-3" v-if="admissionFormSections.length > 0">
            <thead class="thead-dark text-left">
                <tr>
                    <th>No.</th>
                    <th>Section</th>
                    <th></th>

                </tr>
            </thead>
            <tbody>
                <tr v-for="(section, index) in admissionFormSections" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ section.name }}</td>
                    <td>
                        <div class="d-flex align-items-center">
                            <button class="btn btn-sm btn-info me-2 mr-2" @click="viewData(section.id)">
                                Approve
                            </button>

                            <!-- Show Order -->
                            <div v-if="getApprover(section)">
                                <small class="badge bg-secondary">
                                    Order: {{ getApprover(section).order }}
                                </small>
                            </div>
                        </div>
                    </td>


                </tr>
            </tbody>
        </table>

        <!-- Show Admission Form Component when Proceed is clicked -->
        <b-modal v-model="showForm" title="Create Form" hide-footer hide-header centered size="md"
            @hidden="selectedForm = null">
            <admission-form-create :formData="selectedForm" @closeForm="showForm = false"
                @reloadAdmissionFormList="getAdmissionForms()" />
        </b-modal>

        <!-- Create Form Sections Modal -->
        <dashboard-modal
            id="sections-modal"
            title="Create Form"
            icon="fas fa-list-alt"
            parent="Admission Forms"
            @close="closeSectionsModal"
        >
            <admission-form-sections
                v-if="showSectionsModal"
                :initial-form-id="selectedFormId"
                @close="closeSectionsModal"
            />
        </dashboard-modal>

        <!-- Approval Overview Modal -->
        <dashboard-modal
            id="approval-overview-modal"
            title="Approval Overview"
            icon="fas fa-tasks"
            parent="Admission Forms"
            @close="closeApprovalModal"
        >
            <view-students-via-sections
                v-if="showApprovalModal"
                :initial-form-id="selectedApprovalFormId"
                @close="closeApprovalModal"
            />
        </dashboard-modal>
        

        <!-- Approve Section Modal -->
        <dashboard-modal
            id="approve-section-modal"
            title="Approve Section"
            icon="fas fa-check-circle"
            parent="Admission Forms"
            @close="closeApproveSectionModal"
        >
            <view-approver-verification-section-data
                v-if="showApproveSectionModal"
                :initial-section-id="selectedSectionId"
                :initial-admissiondesk="admissiondesk"
                :initial-adminrole-admissiondesk="false"
                @close="closeApproveSectionModal"
            />
        </dashboard-modal>

        <!-- Student Response Overview Modal -->
        <dashboard-modal
            id="student-response-modal"
            title="Student Response Overview"
            icon="fas fa-users"
            parent="Admission Forms"
            @close="closeStudentResponseModal"
        >
            <view-admission-form-full-data
                v-if="showStudentResponseModal"
                :initial-form-id="selectedStudentResponseFormId"
            />
        </dashboard-modal>

        <!-- Header Settings Modal -->
        <b-modal v-model="showHeaderModal" :title="'Form Header Settings - ' + headerForm.name" centered size="md" hide-footer>
            <div>
                <b-form-group label="Header Type">
                    <b-form-radio-group v-model="headerType" :options="[
                        { text: 'Default Header', value: 'default' },
                        { text: 'Custom Image', value: 'custom' }
                    ]" />
                </b-form-group>

                <div v-if="headerType === 'custom'" class="mt-3">
                    <b-form-group label="Upload Header Image">
                        <b-form-file v-model="headerImageFile" accept="image/*" placeholder="Choose an image..." />
                    </b-form-group>
                    <div v-if="headerForm.header_file" class="mt-2">
                        <small class="text-muted">Current:</small>
                        <img :src="$store.getters.getAPIKey.userAttachments + headerForm.header_file.file_path + headerForm.header_file.file_name"
                            style="max-height: 60px; display: block; margin-top: 4px;" />
                    </div>
                </div>

                <div class="text-right mt-4">
                    <b-button variant="secondary" size="sm" class="mr-2" @click="showHeaderModal = false">Cancel</b-button>
                    <b-button variant="primary" size="sm" :disabled="headerSaving" @click="saveHeader">
                        {{ headerSaving ? 'Saving...' : 'Save' }}
                    </b-button>
                </div>
            </div>
        </b-modal>


        <!-- Copy Admission Form Modal -->
        <b-modal v-model="showCopyModal" :title="copyDoneAcademicYear ? 'Form Copied' : 'Copy Admission Form'" centered size="md" hide-footer no-close-on-backdrop :no-close-on-esc="!!copyDoneAcademicYear" @hidden="resetCopyForm">

            <!-- Success acknowledgement view -->
            <div v-if="copyDoneAcademicYear" class="text-center py-3">
                <i class="fas fa-check-circle text-success mb-3" style="font-size: 48px;"></i>
                <p class="mb-1">The admission form has been copied successfully.</p>
                <p class="mb-3">
                    You can find it under academic year
                    <strong class="text-primary">{{ copyDoneAcademicYear }}</strong>.
                </p>
                <b-button variant="primary" @click="showCopyModal = false">OK</b-button>
            </div>

            <!-- Copy form view -->
            <div v-else>
                <b-form-group>
                    <label class="font-weight-bold">Form Name <span class="text-danger">*</span></label>
                    <b-form-input v-model="copyForm.name" placeholder="Enter new form name" />
                </b-form-group>

                <b-form-group>
                    <label class="font-weight-bold">Academic Year <span class="text-danger">*</span></label>
                    <b-form-select v-model="copyForm.academic_year" :options="academicYears" />
                </b-form-group>

                <b-form-group>
                    <label class="font-weight-bold">Start Date <span class="text-danger">*</span></label>
                    <b-form-datepicker v-model="copyForm.start_date" placeholder="Select Start Date" menu-class="w-100" class="w-100" />
                </b-form-group>

                <b-form-group>
                    <label class="font-weight-bold">End Date <span class="text-danger">*</span></label>
                    <b-form-datepicker v-model="copyForm.end_date" placeholder="Select End Date" menu-class="w-100" class="w-100" />
                </b-form-group>

                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="secondary" size="sm" class="mr-2" @click="showCopyModal = false">Cancel</b-button>
                    <b-button variant="success" size="sm" :disabled="copyLoading || !copyForm.name || !copyForm.academic_year || !copyForm.start_date || !copyForm.end_date" @click="submitCopy">
                        <span v-if="copyLoading"><i class="fas fa-spinner fa-spin"></i> Copying...</span>
                        <span v-else><i class="fas fa-copy"></i> Copy Form</span>
                    </b-button>
                </div>
            </div>

        </b-modal>

    </div>
</template>

<script>
import AdmissionFormCreate from './admissionFormCreate.vue';
import AdmissionFormSections from './AdmissionFormSections.vue';
import DashboardModal from '../DashboardModal.vue';
import ViewStudentsViaSections from './ViewStudentsViaSections.vue';
import ViewAdmissionFormFullData from './ViewAdmissionFormFullData.vue';
import ViewApproverVerificationSectionData from './ViewApproverVerificationSectionData.vue';

export default {
    props: ['admissiondesk'],
    async created() {
        this.publicEventUrl = process.env.VUE_APP_BACE_URL;
        await this.fetchInstitutionFaculties();
        await this.getAdmissionForms();
    },

    components: { AdmissionFormCreate, AdmissionFormSections, DashboardModal, ViewStudentsViaSections, ViewAdmissionFormFullData, ViewApproverVerificationSectionData },

    watch: {
        formData: {
            immediate: true,
            handler(newValue) {
                if (newValue) {
                    this.admissionform = { ...newValue };
                } else {
                    this.resetForm();
                }
            },
        },
    },

    data() {
        return {
            showForm: false,
            showSectionsModal: false,
            selectedFormId: null,
            showApprovalModal: false,
            selectedApprovalFormId: null,
            showStudentResponseModal: false,
            selectedStudentResponseFormId: null,
            admissionForms: [],
            admissionFormSections: [],
            approver: null,
            approverIds: [],
            selectedForm: null,
            facultyOptions: [],
            showApproveSectionModal: false,
            selectedSectionId: null,
            showHeaderModal: false,
            headerForm: {},
            headerType: 'default',
            headerImageFile: null,
            headerSaving: false,
            showCopyModal: false,
            copySourceId: null,
            copyForm: { name: '', academic_year: '', start_date: '', end_date: '' },
            copyLoading: false,
            copyDoneAcademicYear: null,
        };
    },
    computed: {
        academicYears() {
            const startYear = 2019;
            const endYear = new Date().getFullYear() + 2;
            return Array.from({ length: endYear - startYear }, (_, i) => {
                const y = startYear + i;
                return `${y}-${String(y + 1).slice(-2)}`;
            });
        },
    },

    methods: {
        openCopyModal(form) {
            this.copySourceId = form.id;
            this.copyForm = { name: `${form.name} (Copy)`, academic_year: '', start_date: '', end_date: '' };
            this.showCopyModal = true;
        },
        resetCopyForm() {
            this.copySourceId = null;
            this.copyDoneAcademicYear = null;
            this.copyForm = { name: '', academic_year: '', start_date: '', end_date: '' };
        },
        async submitCopy() {
            this.copyLoading = true;
            try {
                await this.$axios.post(
                    `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/${this.copySourceId}/copy`,
                    this.copyForm
                );
                this.copyDoneAcademicYear = this.copyForm.academic_year;
                await this.getAdmissionForms();
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Failed to copy form.', { position: 'top', duration: 5000 });
            } finally {
                this.copyLoading = false;
            }
        },
        getFacultyName(id) {
            const faculty = this.facultyOptions.find(f => f.id === id);
            return faculty ? faculty.name.trim() : 'Unknown';
        },
        async fetchInstitutionFaculties() {
            const url = `${this.$store.getters.getAPIKey.mainAPI}/institutionusers/faculties`;
            try {
                const response = await this.$axios.get(url);
                this.facultyOptions = response.data
                    .filter(staff => staff.enroll_status === 'active')
                    .map(staff => ({
                        id: staff.id,
                        name: `${staff.first_name} ${staff.last_name}`
                    }));
            } catch (error) {
                console.error("Error fetching faculty data:", error);
            }
        },
        // a person with several roles may have been added as approver under any of them; the current role's entry wins
        getApprover(section) {
            const ids = this.approverIds.length ? this.approverIds : [this.approver];
            for (const id of ids) {
                const match = section.approvers.find(a => a.institution_user_id == id);
                if (match) return match;
            }
            return null;
        },
        approvalOverview(admissionformId) {
            this.selectedApprovalFormId = admissionformId;
            this.showApprovalModal = true;
            this.$bvModal.show('approval-overview-modal');
        },
        closeApprovalModal() {
            this.$bvModal.hide('approval-overview-modal');
            this.showApprovalModal = false;
            this.selectedApprovalFormId = null;
        },
        viewAdmissionForm(admissionformId) {
            this.selectedStudentResponseFormId = admissionformId;
            this.showStudentResponseModal = true;
            this.$bvModal.show('student-response-modal');
        },
        closeStudentResponseModal() {
            this.$bvModal.hide('student-response-modal');
            this.showStudentResponseModal = false;
            this.selectedStudentResponseFormId = null;
        },
        viewData(section_id) {
            this.selectedSectionId = section_id;
            this.showApproveSectionModal = true;
            this.$bvModal.show('approve-section-modal');
        },
        closeApproveSectionModal() {
            this.$bvModal.hide('approve-section-modal');
            this.showApproveSectionModal = false;
            this.selectedSectionId = null;
        },
        createSection(admissionformId) {
            this.selectedFormId = admissionformId;
            this.showSectionsModal = true;
            this.$bvModal.show('sections-modal');
        },
        closeSectionsModal() {
            this.$bvModal.hide('sections-modal');
            this.showSectionsModal = false;
            this.selectedFormId = null;
        },
        /**
         * The public link for a form. Built through the router rather than by
         * concatenating VUE_APP_BACE_URL, because the router's base carries the
         * institution slug (see resolveRouterBase) and a hand-built string does
         * not - which is why the shown link used to differ from the copied one.
         */
        publicFormUrl(form) {
            const base = this.publicEventUrl.replace(/#.*$/, "").replace(/\/$/, "");
            const route = this.$router.resolve({
                name: "admissionformPublicURL",
                params: { admissionform_id: form.id },
            });

            return `${base}${route.href}`;
        },
        async copyLink(index) {
            const url = this.publicFormUrl(this.admissionForms[index]);
            await navigator.clipboard.writeText(url);
            this.$toast.info("Copied to clipboard", {
                position: "top-right",
                duration: 3000,
            });
        },
        resetForm() {
            this.admissionform = { name: "", academic_year: "", start_date: "", end_date: "" };
        },
        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        async getAdmissionForms() {
            const url = `${this.$store.getters.getAPIKey.mainAPI}/admissionforms?is_admissiondesk=${this.admissiondesk}&is_approval=${true}`;
            await this.$axios
                .get(url)
                .then((response) => {
                    this.admissionForms = response.data.admissionforms ?? [];
                    this.admissionFormSections = response.data.sections ?? [];
                    this.approver = response.data.approver ?? [];
                    this.approverIds = response.data.approver_ids ?? [];
                })
                .catch((error) => {
                    let errortxt = error.response.data.message ?? 'Failed to Submit, please try agin';
                    this.$toast.error(errortxt, {
                        position: "top",
                        duration: 7000,
                    });
                });
        },

        openHeaderModal(form) {
            this.headerForm = { ...form };
            this.headerType = form.header_type || 'default';
            this.headerImageFile = null;
            this.showHeaderModal = true;
        },
        async saveHeader() {
            this.headerSaving = true;
            try {
                const formData = new FormData();
                formData.append('header_type', this.headerType);
                if (this.headerType === 'custom' && this.headerImageFile) {
                    formData.append('header_image', this.headerImageFile);
                }
                await this.$axios.post(
                    `${this.$store.getters.getAPIKey.mainAPI}/admissionforms/${this.headerForm.id}/header`,
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                this.$toast.success('Header saved.', { position: 'top', duration: 3000 });
                this.showHeaderModal = false;
                await this.getAdmissionForms();
            } catch (e) {
                this.$toast.error(e.response?.data?.message || 'Failed to save header.', { position: 'top', duration: 4000 });
            } finally {
                this.headerSaving = false;
            }
        },
        editAdmissionForm(form) {
            this.selectedForm = { ...form }; // Clone form data to avoid modifying the list directly
            this.showForm = true;  // Open the form modal
        },

    },
};
</script>
